// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentsListColumns-EmptyResultContainer_cls1__E4ilI","cls2":"PaymentsListColumns-EmptyResultContainer_cls2__LjIHA PaymentsListColumns-EmptyResultContainer_cls1__E4ilI"};